import Icon from '../../../../icons/Icon';
import React, { Component, ReactNode } from 'react';
import NotificationClient from '../../../../client/notification/NotificationClient';
import GatewayContainer from '../../../../config/GatewayContainer';
import GatewayNames from '../../../../constant/GatewayNames';
import LanguageUtil from '../../../../util/LanguageUtil';

class NotificationHeaderComponent extends Component {
  private readonly notificationClient: NotificationClient = GatewayContainer.getInstance().get(GatewayNames.NOTIFICATION_CLIENT);

  public render(): ReactNode {
    return (
      <div className='flex items-center justify-between px-5 py-5 border-b-[1px] border-b-[#E0E4E8]'>
        <div className=' flex items-center'>
          <span className='text-[#4F4F4F]'>
            <Icon icon='notifications' size={24} />
          </span>
          <span className='ml-1 text-f-black-2 text-center'>{LanguageUtil.get({ id: 'common.label.notification' })}</span>
        </div>
        <div onClick={this.readAll} className='text-[#458EF7] cursor-pointer hover:opacity-50'>
          {LanguageUtil.get({ id: 'common.label.markAllAsRead' })}
        </div>
      </div>
    );
  }

  private readAll = async () => {
    await this.notificationClient.readAll();
  };
}

export default NotificationHeaderComponent;
